const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Направете своя избор тук",
  seeAll: "Виж всички",
  clear: "Изчисти",
  back: "Назад",
  save: "Запази",
  close: "Затвори",
  of: "от",
  to: "до",
  copyrights: "© {date} Bridgestone Solutions. Всички права запазени.",
  pageNotFound: "Страницата не е намерена",
  accessDenied: "Достъпът е отказан",
  search: "Търсене",
  year: "Година",
  buttons: {
    loading: "Зареждане...",
    export: "Експортиране",
    delete: "Изтрий",
    save: "Запази",
    cancel: "Отказ",
    next: "Напред",
    back: "Назад",
    skip: "Пропусни",
    send: "Изпрати",
    pointsList: "Списък с точки",
    clear: "Изчисти",
    readNow: "прочетете сега",
    more: "повече",
    close: "Затвори",
    reportError: "Докладване за грешка",
    accept: "Приеми",
    download: "Изтегли",
    downloadAll: "Изтегли всички",
    selectAll: "Избери всички",
    deselectAll: "Премахни избора",
    downloadSelection: "Изтегли избраното",
    dealerInfoDownload: "ИЗТЕГЛИ",
    toTheBasket: "Към кошницата",
    toOrderDelivery: "Продължи към адреса за доставка",
    discover: "Открий",
    newAddress: "Създай нов адрес за доставка",
    selectAddressBtn: "Избери адрес за доставка",
    toOrderSummary: "Към прегледа на поръчката",
    placeOrder: "Обвързваща поръчка",
    toDashboard: "Към началната страница",
    newOrder: "Нова поръчка",
    userOrders: "Към твоите поръчки",
    toSearch: "Търсене",
    select: "Избери",
    moreCustomerNumbers: "+ ДОБАВИ ОЩЕ КЛИЕНТСКИ НОМЕРА",
    setFilters: "Indstil venligst dit filter",
    loadMore: "Зареди още",
    toStaffDashboard: "Към таблото",
    toQuiz: "Към теста",
    vouchers: "Ваучери",
    exchangeVoucher: "Осребри код за ваучер",
    confirm: "Потвърди",
    sharePoints: "Сподели точки",
    create: "Създай",
    update: "Обнови",
    toBDrive: "Към B-Drive",
    preview: "Преглед",
    clickHere: "Вижте детайлите",
    all: "Всички",
  },
  tooltips: {
    info: "Нуждаете се от помощ? xx xx xx xx",
  },
  confirmation: {
    header: "Изисква се потвърждение",
    message: "Искате ли да изтриете този запис?",
  },
  nav: {
    consents: "Съгласия",
    dashboard: "Начало",
    accountDashboard: "Табло",
    account: "моя профил",
    mailbox: "Входяща поща",
    singleMailbox: "Съобщения",
    stammdaten: "Основни данни",
    news_feeds: "Новини",
    pointsOverview: "Преглед на точки",
    rewardsOverview: "Преглед на точки",
    about: "За BS Plus",
    service_number: "Контакти и обслужване",
    shop: "Магазин за награди",
    salesPromotions: "Търговски промоции",
    promotions: "Моят акаунт",
    shopCategory: "Магазин за награди",
    productDetails: "Детайли за продукта",
    userOrders: "Потребителски поръчки",
    shoppingCart: "Количка",
    orderDelivery: "Адрес за доставка",
    orderSummary: "Преглед на поръчката",
    orderComplete: "Поръчката е завършена",
    text_page: "Статична страница",
    staff: "Сервизно табло",
    onlineTrainings: "Онлайн обучения",
    trainings: "Обучения",
    training: "Обучение",
    trainingForm: "Форма за обучение",
    staffVouchers: "Ваучери",
    wholesalerVouchers: "Ваучери",
    brochure_prices: "Ценови листи и брошури",
    investment: "Podkrepa za investicii",
    media: "Медия",
    medias: "Медия",
    contact_service: "Контакти и обслужване",
    productInfo: "ИНФОРМАЦИЯ ЗА ПРОДУКТА",
    bDrive: "Снимки на продукти",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Условия за участие",
    first_stop: "Гаранция за гуми Bridgestone",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Начало",
    accountDashboard: "Табло",
    account: "моя профил",
    mailbox: "Входяща поща",
    singleMailbox: "Съобщения",
    stammdaten: "Основни данни",
    news_feeds: "Новини",
    pointsOverview: "Преглед на точки",
    rewardsOverview: "Преглед на точки",
    about: "За BS Plus",
    service_number: "Контакти и обслужване",
    shop: "Магазин за награди",
    salesPromotions: "Търговски промоции",
    promotions: "Моят акаунт",
    shopCategory: "Магазин за награди",
    productDetails: "Детайли за продукта",
    userOrders: "Потребителски поръчки",
    shoppingCart: "Количка",
    orderDelivery: "Адрес за доставка",
    orderSummary: "Преглед на поръчката",
    orderComplete: "Поръчката е завършена",
    staff: "Сервизно табло",
    onlineTrainings: "Онлайн обучения",
    trainings: "Обучения",
    training: "Обучение",
    trainingForm: "Форма за обучение",
    staffVouchers: "Ваучери",
    wholesalerVouchers: "Ваучери",
    brochure_prices: "Ценови листи и брошури",
    investment: "Podkrepa za investicii",
    media: "Медия",
    medias: "Медия",
    contact_service: "Контакти и обслужване",
    productInfo: "ИНФОРМАЦИЯ ЗА ПРОДУКТА",
    bDrive: "Снимки на продукти",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Условия за участие",
    first_stop: "Гаранция за гуми Bridgestone",
    payouts: "Payouts",
},
  menu: {
    account: "моя профил",
    plus: 'За Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Търговска подкрепа",
    mailbox: "Входяща поща",
    about: "За BS Plus",
    trainingAndCourses: "Обучения и курсове",
    externalTraining: "Външно обучение",
    productInfo: "Информация за продукта",
    productBrochures: "Брошури на продуктите",
    priceLists: "Ценови листи",
    price: "Цена",
    complaintForm: "Формуляр за жалби",
    sales_support: "Търговска подкрепа",
    contact_service: "Контакти и обслужване",
    logOut: "Изход",
    news: "Новини",
    news_feeds: "Новини",
    service_number: "Контакти и обслужване",
    salesPromotions: "Търговски промоции",
    shop: "Магазин",
    onlineTrainings: "Онлайн обучения",
    trainings: "Обучения",
    brochure_prices: "Ценови листи и брошури",
    media: "Медия",
    medias: "Медия",
    stammdaten: "Основни данни",
    preislisten: "Ценови листи",
  },
  validation: {
    requiredField: "Задължително поле",
  },
  sortBy: {
    default: "Сортирай по",
    desc: "Сортирай по: Най-нови",
    asc: "Сортирай по: Най-стари",
    name: "Име",
    date: "Дата",
    choiceBy: "Сортирай",
  },
  month: {
    1: "януари",
    2: "февруари",
    3: "март",
    4: "април",
    5: "май",
    6: "юни",
    7: "юли",
    8: "август",
    9: "септември",
    10: "октомври",
    11: "ноември",
    12: "декември"
  },
};


export default {
  messages,
};
